const textContainer = document.getElementById("fullPublication");
const toggleBtns = document.querySelectorAll(".openPublication");
const tableOfContents = document.querySelectorAll(".tableOfContents");

// Get all focusable elements inside the expandable content
function updateTabIndex(textContainer, expanded) {
    if (textContainer && textContainer instanceof Element) {
        const focusableElements = textContainer.querySelectorAll("a, button");
        focusableElements.forEach(function (el) {
            el.setAttribute("tabindex", expanded ? "0" : "-1");
        });
    } else {
        console.warn("textContainer is not a valid element:", textContainer);
    }
}

toggleBtns.forEach(function (btn) {
    btn.addEventListener("click", function (event) {
        event.preventDefault(); // Prevent default link behavior

        const readMoreText = btn.dataset.readmore; // Text for "Read More"
        const showLessText = btn.dataset.showless; // Text for "Show Less"

        if (textContainer.classList.contains("expanded")) {
            // Collapse the text
            textContainer.classList.remove("expanded");
            toggleBtns.forEach((b) => b.classList.remove("rotate"));
            tableOfContents.forEach((c) => c.classList.remove("show"));

            // Update all buttons' text to "Read More"
            toggleBtns.forEach((b) => (b.textContent = readMoreText));

            updateTabIndex(false); // Disable tabbing inside hidden content
        } else {
            // Expand the text
            textContainer.classList.add("expanded");
            toggleBtns.forEach((b) => b.classList.add("rotate"));
            tableOfContents.forEach((c) => c.classList.add("show"));

            // Update all buttons' text to "Show Less"
            toggleBtns.forEach((b) => (b.textContent = showLessText));

            updateTabIndex(true); // Enable tabbing inside the content

            // Move focus to the expanded section (optional for better accessibility)
            textContainer.setAttribute("tabindex", "-1");
            textContainer.focus();
        }
    });
});

// Check if the URL contains a hash
const hash = window.location.hash;
if (hash) {
    // Find the text container matching the hash
    const targetTextContainer = document.querySelector(hash);

    if (targetTextContainer) {
        // Add the "expanded" class to the target text container
        textContainer.classList.add("expanded");

        // Loop through all toggle buttons and update the ones associated with the target text container
        toggleBtns.forEach((btn) => {
            const showLessText = btn.dataset.showless; // Text for "Show Less"

            // Update the button's text to "Show Less"
            btn.textContent = showLessText;

            // Add the "rotate" class to all toggle buttons
            toggleBtns.forEach((b) => b.classList.add("rotate"));

            // Show table of contents (if applicable)
            tableOfContents.forEach((c) => c.classList.add("show"));

            // Enable tabbing inside the content
            updateTabIndex(targetTextContainer, true);

            // Focus on the expanded section (optional for accessibility)
            targetTextContainer.setAttribute("tabindex", "-1");
            targetTextContainer.focus();
            
        });

        // Scroll the page to the top of the target section after a short delay
        targetTextContainer.scrollIntoView({
            behavior: "smooth",
            block: "start" // Align to the top of the container
        });

        // After a slight delay, adjust the scroll position by the 5rem offset
        setTimeout(() => {
            const offset = 5 * 16; // 5rem in pixels (assuming base font-size is 16px)
            window.scrollBy(0, -offset); // Scroll up by the offset (5rem)
        }, 700); // Delay to allow the scrollIntoView to complete
    }
}